import api from "./client";

export const adminService = {
    stats: () => api.get("/admin/stats").then((r) => r.data),
    users: (params = {}) => api.get("/admin/users", { params }).then((r) => r.data),
    setLevel: (id, level) =>
        api
            .put(`/admin/users/${id}/level`, { userLevel: level })
            .then((r) => r.data),
    deleteUser: (id) =>
        api.delete(`/admin/users/${id}`).then((r) => r.data),
    generate: (date) =>
        api
            .post("/admin/predictions/generate", date ? { date } : {})
            .then((r) => r.data),
    evaluate: (date) =>
        api
            .post("/admin/predictions/evaluate", date ? { date } : {})
            .then((r) => r.data),
    diagnose: () =>
        api.get("/admin/predictions/diagnose").then((r) => r.data),
    subscriptions: (params = {}) =>
        api.get("/admin/subscriptions", { params }).then((r) => r.data),
};
